import { defaults } from "react-chartjs-2";
import Color from "color"; 

// set global chartjs defaults
defaults.global.responsive = true;
defaults.global.defaultColor = "rgba(0,0,90,0.7)";
defaults.global.legend.position = "bottom";
defaults.global.legend.labels.pointStyle = "circle";
defaults.global.legend.labels.usePointStyle = true;
defaults.global.legend.labels.fontSize = 12;

//get theme colors to set chart dataset colors
document.body.innerHTML += '<span class="bg-light"></span>';
document.body.innerHTML += '<span class="bg-dark"></span>';
document.body.innerHTML += '<span class="bg-primary"></span>';
document.body.innerHTML += '<span class="bg-secondary"></span>';
document.body.innerHTML += '<span class="bg-danger"></span>';
document.body.innerHTML += '<span class="bg-info"></span>';
document.body.innerHTML += '<span class="bg-warning"></span>';
document.body.innerHTML += '<span class="bg-success"></span>';

var theme = {};
theme.light = getComputedStyle(document.querySelector('.bg-light')).getPropertyValue("background-color");
theme.dark = getComputedStyle(document.querySelector('.bg-dark')).getPropertyValue("background-color");
theme.primary = getComputedStyle(document.querySelector('.bg-primary')).getPropertyValue("background-color");
theme.secondary = getComputedStyle(document.querySelector('.bg-secondary')).getPropertyValue("background-color");
theme.danger = getComputedStyle(document.querySelector('.bg-danger')).getPropertyValue("background-color");
theme.info = getComputedStyle(document.querySelector('.bg-info')).getPropertyValue("background-color");
theme.warning = getComputedStyle(document.querySelector('.bg-warning')).getPropertyValue("background-color");
theme.success = getComputedStyle(document.querySelector('.bg-success')).getPropertyValue("background-color");

const chartDefaults = defaults;
const chartHelpers = {
  
  // chart dataset colors are set from theme colors
  colors:[
    {
      borderWidth: 0,
      borderColor: Color("#dddddd").fade(0.3).rgb(),
      backgroundColor: Color("#dddddd").whiten(0.7).fade(0.3).rgb(),
      pointBackgroundColor: Color("#dddddd").fade(0.2).rgb(),
      pointBorderColor: Color("#dddddd").blacken(0.3).rgb(),
      pointHoverBorderColor: Color("#dddddd").blacken(0.5).rgb(),
      pointHoverBorderWidth: 1
    },
    {
      borderWidth: 0,
      borderColor: Color(theme.primary).lighten(0.3).hex(),
      backgroundColor: Color(theme.primary).lighten(0.4).hex(),
      pointBackgroundColor: theme.primary,
      pointBorderColor: "rgba(20,20,20,0.4)",
      pointHoverBorderColor: "rgba(20,20,20,0.7)",
      pointHoverBorderWidth: 1
    },
    {
      borderWidth: 0,
      borderColor: Color(theme.primary).darken(0.4).rgb(),
      backgroundColor: Color(theme.primary).darken(0.3).rgb(),
      pointBackgroundColor: theme.primary,
      pointBorderColor: "rgba(20,20,20,0.4)",
      pointHoverBorderColor: "rgba(20,20,20,0.7)",
      pointHoverBorderWidth: 1
    },
    {
      borderWidth: 0,
      borderColor: Color(theme.info).darken(0.1).rgb(),
      backgroundColor: theme.info,
      pointBackgroundColor: theme.info,
      pointBorderColor: theme.info,
      pointHoverBorderColor: Color(theme.info).darken(0.2).rgb(),
      pointHoverBorderWidth: 1
    },
    {
      borderWidth: 0,
      borderColor: Color(theme.success).darken(0.1).rgb(),
      backgroundColor: theme.success,
      pointBackgroundColor: theme.success,
      pointBorderColor: theme.success,
      pointHoverBorderColor: Color(theme.success).darken(0.2).rgb(),
      pointHoverBorderWidth: 1
    },
    {
      borderWidth: 0,
      borderColor: Color(theme.danger).darken(0.1).rgb(),
      backgroundColor: theme.danger,
      pointBackgroundColor: theme.danger,
      pointBorderColor: theme.danger,
      pointHoverBorderColor: Color(theme.danger).darken(0.2).rgb(),
      pointHoverBorderWidth: 1
    }
  ],
  
  mergeColorsIntoData:function(srcData){
    /* This function merges from a "global" colors array into datadset 
     * colors. This allow us to dynamically change the colors and keep
     * the color definitions separate from the data.
    */
    return {
      ...srcData,
      datasets: srcData.datasets.map((dataset, k) => {
        return { ...dataset, ...this.colors[k] };
      })
    };
  },
  
  mergeColorsIntoPieData:function(srcData){
    /* This function merges from "global" colors array into pie data colors. 
     * Since pie charts use an arr of backgroundColor for each pie segment, we
     * resample from the other color arr indexes and push onto backgroundColor
    */
    var pieColors = this.colors;
    var thisColors = [{}];
    return {
      ...srcData,
      datasets: srcData.datasets.map((dataset, k) => {
        thisColors[k].backgroundColor = [pieColors[k].backgroundColor];
        thisColors[k].backgroundColor.push(
          pieColors[k + 1].backgroundColor
        );
        thisColors[k].backgroundColor.push(
          pieColors[k + 2].backgroundColor
        );
        return { ...dataset, ...thisColors[k] };
      })
    };
  }
};

export {
  chartHelpers,
  chartDefaults
};
